import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

import { CuroAppRoute } from 'enums/curo/CuroAppRoute';
import { useAppProgressBar, AppProcessSteps } from 'hooks/useAppProgressBar';
import { useCurrentStep } from 'hooks/useCurrentStep';
import CuroMainLayout from 'layout/CuroMainLayout';

import { ApplyProcessSteps } from './constants';
import ApplyFormStep from './steps/ApplyFormStep';
import ContactInformationFormStep from './steps/ContactInformationFormStep';
import SignInStep from './steps/SignInStep';

const ApplyProcess = () => {
  const { setProgressStep, resetProgress } = useAppProgressBar();

  const [applyProcessStep, setApplyProcessStep] = useCurrentStep<ApplyProcessSteps>(
    ApplyProcessSteps.ApplyForm,
  );

  const navigate = useNavigate();

  useEffect(() => {
    const updateProgressBar = () => {
      switch (applyProcessStep) {
        case ApplyProcessSteps.ApplyForm:
        case ApplyProcessSteps.ContactInformation:
          setProgressStep(AppProcessSteps.ApplyProcessStep);
          break;
        case ApplyProcessSteps.SignIn:
          resetProgress();
          break;
        default:
          return;
      }
    };

    updateProgressBar();
  }, [applyProcessStep]);

  const renderByStep = () => {
    switch (applyProcessStep) {
      case ApplyProcessSteps.ApplyForm:
        return (
          <ApplyFormStep
            onStepComplete={() => setApplyProcessStep(ApplyProcessSteps.ContactInformation)}
          />
        );
      case ApplyProcessSteps.ContactInformation:
        return (
          <ContactInformationFormStep
            onBackButtonClick={() => setApplyProcessStep(ApplyProcessSteps.ApplyForm)}
            onStepComplete={() => setApplyProcessStep(ApplyProcessSteps.SignIn)}
          />
        );
      case ApplyProcessSteps.SignIn:
        return <SignInStep onStepComplete={() => navigate(CuroAppRoute.ResumeProcess)} />;
      default:
        return null as never;
    }
  };

  return <CuroMainLayout>{renderByStep()}</CuroMainLayout>;
};

export default ApplyProcess;
